<template>
  <div>
    <public-header></public-header>
    <div class="height70"></div>
    <router-view></router-view>
    <public-footer></public-footer>
    <back-top></back-top>
  </div>
</template>
<script>
import PublicHeader from '@/components/PublicHeader'
import PublicFooter from "@/components/PublicFooter.vue";
import BackTop from "@/components/BackTop.vue";
export default {
  name: 'EnterpriseRegister',
  components: {
    PublicHeader,
    PublicFooter,
    BackTop
  },
  methods: {
    checkLogin () {
      if (!this.$store.state.code) {
        this.$router.push('/login')
      } else if (this.$store.state.user_type === 1) {
        this.$message.error('很抱歉，您不是企业用户，请注册认证！');
        this.$router.push('/')
      }
      // } else if (this.$store.state.user_type === 0 && this.$store.state.is_auth === 0) {
      //   this.$router.push('/enterprise-register/result')
      // }  else if (this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 0) {
      //   this.$router.push('/enterprise-register/result')
      // } else if (this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 1) {
      //   this.$router.push('/enterprise/manage')
      // }
    }
  },
  created() {
    this.checkLogin();
  }
}
</script>
<style scoped></style>
